import { api } from '@goaltree/backend/convex/_generated/api'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useMutation } from 'convex/react'
import { ConvexError } from 'convex/values'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { z } from 'zod'

import { UpgradeDialog } from '@/components/upgrade-dialog'

// gt.today/s/<id> "Start this plan": copies the story's plan into the signed-in account.
export const Route = createFileRoute('/_authenticated/action/start-story')({
  validateSearch: z.object({ id: z.string() }),
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { id } = Route.useSearch()
  const navigate = useNavigate()
  const startPlan = useMutation(api.journeys.startPlan)
  const [limit, setLimit] = useState(false)
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true
    startPlan({ id })
      .then((goalId) => {
        toast.success(t('leaderboard.profile.planCopied'))
        navigate({ to: '/goals/$goalId', params: { goalId }, replace: true })
      })
      .catch((err) => {
        if (err instanceof ConvexError && String(err.data).includes('Free plan is limited'))
          return setLimit(true)
        toast.error(t('journey.startFailed'))
        navigate({ to: '/today', replace: true })
      })
  }, [id, navigate, startPlan, t])

  return (
    <div className="flex h-svh items-center justify-center">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      <UpgradeDialog
        open={limit}
        onOpenChange={(o) => {
          if (o) return
          setLimit(false)
          navigate({ to: '/today', replace: true })
        }}
        reason="goal-limit"
      />
    </div>
  )
}
